import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface BestWeek {
  week: string;
  record: string;
}

interface TeamRecord {
  logoUrl: string; 
  name: string;
  isMostPicked: boolean;
  picks: string;
  record: string;
}

interface CommonLine {
  spread: string;
  occurrences: number;
}

@Component({
  selector: 'app-season-results-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './season-results-section.component.html',
  styleUrls: ['./season-results-section.component.scss']
})

export class SeasonResultsSectionComponent {


  bestWeeks: BestWeek[] = [
    { week: 'Week 6', record: '11W-0L' },
    { week: 'Week 12', record: '12W-2L' },
    { week: 'Week 3', record: '10W-1L' },
  ];

  topPickedTeams: TeamRecord[] = [
    { logoUrl: 'https://imgix.cosmicjs.com/bdba3950-5a7f-11f0-ae5a-0f56aa053fcd-WVU-1.svg?auto=format,compress', name: 'West Virginia', isMostPicked: true, picks: '5 picks', record: '4-1' },
    { logoUrl: 'https://imgix.cosmicjs.com/bdb900d0-5a7f-11f0-ae5a-0f56aa053fcd-WF-1.svg?auto=format,compress', name: 'Wake Forest', isMostPicked: false, picks: '4 picks', record: '4-0' },
    { logoUrl: 'https://imgix.cosmicjs.com/bdb9c420-5a7f-11f0-ae5a-0f56aa053fcd-MICH-2-1.svg?auto=format,compress', name: 'Michigan State', isMostPicked: false, picks: '4 picks', record: '2-2' },
    { logoUrl: 'https://imgix.cosmicjs.com/bdd98120-5a7f-11f0-ae5a-0f56aa053fcd-ASU-1.svg?auto=format,compress', name: 'Arizona', isMostPicked: false, picks: '3 picks', record: '2-1' },
    { logoUrl: 'https://imgix.cosmicjs.com/bdb7c850-5a7f-11f0-ae5a-0f56aa053fcd-NW-1.svg?auto=format,compress', name: 'Northwestern', isMostPicked: false, picks: '3 picks', record: '2-1' },
  ];

  mostCommonLines: CommonLine[] = [
    { spread: '+0.5', occurrences: 44 },
    { spread: '+3.5', occurrences: 27 },
    { spread: '+2.5', occurrences: 21 },
    { spread: '+3.0', occurrences: 16 },
    { spread: '+1.5', occurrences: 10 },
  ];

  constructor() {}
}